import { computed } from 'vue'
import { useStore } from 'vuex'

export function useRowActionVisibility() {
  const store = useStore()
  
  const rowActionVisible = computed(() => 
    store.state.itemList.selectedItems.length > 0
  )
  
  return {
    rowActionVisible
  }
}